/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubmissionCreateRequestState } from './submissionCreateRequestState';
import type { SubmissionCreateRequestLastKnownEtag } from './submissionCreateRequestLastKnownEtag';

/**
 * Submission
 */
export interface SubmissionCreateRequest {
  /**
   * Submission text content (max 5MB safety limit)
   * @maxLength 5000000
   */
  text: string;
  state?: SubmissionCreateRequestState;
  /** ETag of last known submission version for optimistic concurrency control */
  lastKnownEtag?: SubmissionCreateRequestLastKnownEtag;
}
